import { useState } from 'react'
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography,
} from '@mui/material'

import CardTAG from '../CardTAG'
import { IQuestionV2, MainObject } from '../../store/reports/types'
import FormLayout from '../forms/FormLayout'
import reportsSelectors from '../../store/reports/reportsSelectors'
import selectOptions from '../../constants/selectOptions'
import LabelErrorTAG from '../LabelErrorTAG'

import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import { selectStyle, textAreaStyle } from '../../constants/styleConstants'
import { 
  setReporterValues,
  findItemByUuid
} from '../../store/reports/reportsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import { IQuestionComponent } from './types'
import authSelectors from '../../store/auth/authSelectors'


const ReporterFormQuestionComponent: React.FC<IQuestionComponent> = ({
  questionObj,
  question,
  questionUUID,
  questionId,
  questionOptions,
  control,
  fieldName,
  unregister,
  setValue,
  setAnswersFiles,
  answers = [],
  parent,
  previewOnly = false,
}) => {
  

  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const dispatch = useDispatch<AppDispatch>()
  const getAnswer = () => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, questionUUID)
    }
    return useSelector(reportsSelectors.answersToCaseTypeQuestion(questionUUID))
  }
  const answer = getAnswer()

  const answerJson: any = answer?.answer.text.trim() ? JSON.parse(answer?.answer.text) : {
      full_name: '',
      person_type: '',
      phone_number: '',
      email: '',
      work_site: '',
      city: '',
      work_country: '',
    }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setReporterValues({ answerUUID: answer?.uuid, field: e.target.name, value: e.target.value }))
  }

  const onChangeHandler = (e: SelectChangeEvent) => {
    dispatch(setReporterValues({ answerUUID: answer?.uuid, field: e.target.name, value: e.target.value }))
  }

 

  return (
    <div id={`${questionId}`}>
      <CardTAG
        questionCard={true}
        color={`${previewOnly ? 'tagBoxArchive' : 'tagBoxSuccess'}`}
        title={
          <Box sx={{ wordWrap: 'break-word', whiteSpace: 'unset', textOverflow: 'unset' }}>
            <Typography
              variant='h4'
              sx={{
                wordWrap: 'break-word',
                overflow: 'hidden',
              }}
            >
              {question}
            </Typography>
          </Box>
        }
        
      >
        <FormLayout>
        {/* <Stack>
            <span
              style={{ marginBottom: '.7rem' }}
              className='t-font-bold t-font-size-xxs t-color-black'
            >
              {question}
            </span>
            <Select
              onChange={onChangeHandler}
              value={answerJson.person_type as string}
              IconComponent={ArrowIcon}
              displayEmpty
              disabled={!userEditAccess || previewOnly}
              sx={[selectStyle]}
              id='person_type'
              name='person_type'
            >
              {selectOptions.reportingPartyTypes.map(option => {
                return (
                  <MenuItem value={option?.value} key={option?.value}>
                    <Typography variant='bodyBold'>{option?.label}</Typography>
                  </MenuItem>
                )
              })}
            </Select>
          </Stack> */}
          <Stack>
            <LabelErrorTAG label='Full Name' />
            <TextField
              value={answerJson.full_name}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='full_name'
              name='full_name'
              disabled={!userEditAccess || previewOnly}
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Phone Number' />
            <TextField
              value={answerJson.phone_number}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='phone_number'
              name='phone_number'
              disabled={!userEditAccess || previewOnly}
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Email Address' />
            <TextField
              value={answerJson.email}
              onChange={onChange}
              variant='standard'
              type={'email'}
              fullWidth
              id='email'
              name='email'
              disabled={!userEditAccess || previewOnly}
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Work Site' />
            <TextField
              value={answerJson.work_site}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='work_site'
              name='work_site'
              disabled={!userEditAccess || previewOnly}
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Work City' />
            <TextField
              value={answerJson.city}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='city'
              name='city'
              disabled={!userEditAccess || previewOnly}
            />
          </Stack>
          <Stack>
            <LabelErrorTAG label='Work Country' />
            <TextField
              value={answerJson.work_country}
              onChange={onChange}
              variant='standard'
              type={'text'}
              fullWidth
              id='work_country'
              name='work_country'
              disabled={!userEditAccess || previewOnly}
            />
          </Stack>
        </FormLayout>
        
        </CardTAG>
      </div>
  )
}

export default ReporterFormQuestionComponent
